/* Aus snippets/compatibility-help.liquid ausgelagert (vorher Inline-Skript in jeder Seite) */
  (function () {
    if (window.__s4tCompatHelp) return;
    window.__s4tCompatHelp = true;
    function closeAll(except) {
      document.querySelectorAll('[data-compat-help].is-open').forEach(function (el) {
        if (el === except) return;
        el.classList.remove('is-open');
        var b = el.querySelector('.compat-help__btn'); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.compat-help__btn');
      if (btn) {
        var box = btn.closest('[data-compat-help]');
        var open = !box.classList.contains('is-open');
        closeAll(box);
        box.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (!e.target.closest('.compat-help__pop')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

    /* "Passend fuer"-Tags in der Reihenfolge der Fahrzeug-Varianten darunter
       (gleiche Zuordnung wie die Kachel-Farben in main-product.liquid). */
    function genOf(text) {
      var t = (text || '').toLowerCase();
      if (t.indexOf('model') === -1) return '';
      if (t.indexOf('02.2025') > -1) return 'bis_02_2025';
      if (t.indexOf('09.2023') > -1) return 'bis_09_2023';
      if (t.indexOf('highland') > -1) return 'highland';
      if (t.indexOf('premium') > -1 || t.indexOf('performance') > -1) return 'juniper_premium';
      if (t.indexOf('standard') > -1) return 'juniper_standard';
      return '';
    }
    function sortBadges(root) {
      (root || document).querySelectorAll('.product-compatibility__badges').forEach(function (wrap) {
        var scope = wrap.closest('.product-information--inner, #Product-Drawer-Content, .thb-product-detail') || document;
        var order = [];
        scope.querySelectorAll('.variations input[type="radio"]').forEach(function (inp) {
          var g = genOf(inp.value);
          if (g && order.indexOf(g) === -1) order.push(g);
        });
        if (order.length < 2) return;
        var badges = Array.prototype.slice.call(wrap.children);
        badges.sort(function (a, b) {
          var ia = order.indexOf((a.className.match(/badge--([a-z0-9_]+)/) || [])[1]);
          var ib = order.indexOf((b.className.match(/badge--([a-z0-9_]+)/) || [])[1]);
          return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        });
        badges.forEach(function (el) { wrap.appendChild(el); });
      });
    }
    window.s4tSortCompat = sortBadges;
    function initSort() {
      sortBadges();
      var drawer = document.getElementById('Product-Drawer-Content');
      if (drawer && window.MutationObserver) new MutationObserver(function () { sortBadges(drawer); }).observe(drawer, { childList: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSort); else initSort();
  })();
